import styles from "./Footer.module.scss";
import Logo from "../common/Logo.js";
import InternalLink from "../common/InternalLink.js";
import ExternalLink from "../common/ExternalLink.js";
import { isTestnetPath } from "../../../lib/helper.js";

import { socials } from "../../../data/socials.js";

export default function Footer() {
	const allSocialData = socials;

	const year = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
			<div className={styles.row_1}>
				<div>
					<Logo/>
				</div>
				<div className={styles.social_container}>
					{
						allSocialData.map((socialData, index) => {
							return (
								<div key={index}>
									<ExternalLink link={socialData.link}>
										<div className={styles.social_icon_container}>
											<img className={styles.social_icon} src={socialData.imagePath} alt={socialData.altText}/>
										</div>
									</ExternalLink>
								</div>
							);
						})
					}
				</div>
			</div>

			<hr/>

			<div className={styles.row_2}>
				<div className={styles.info_block}>
					<div>dApps</div>
					<div>
						<div><InternalLink link={"/dapps/staking"}>&#8250; Staking Pools</InternalLink></div>
						<div><InternalLink link={"/dapps/mytokens"}>&#8250; MY Tokens</InternalLink></div>
						<div><InternalLink link={"/dapps/feereducer"}>&#8250; Fee Reducer</InternalLink></div>
						<div><InternalLink link={"/dapps/staking#migrate"}>&#8250; Teneo Migrator</InternalLink></div>
					</div>
				</div>
				<div className={styles.info_block}>
					<div>NFTs</div>
					<div>
						<div><InternalLink link={"/nfts/mint"}>&#8250; NFT Editor</InternalLink></div>
						<div><InternalLink link={"/nfts/list"}>&#8250; NFT List</InternalLink></div>
						{
							isTestnetPath() &&
							<div><InternalLink link={"/nfts/marketplace"}>&#8250; NFT Marketplace</InternalLink></div>
						}
					</div>
				</div>
				<div className={styles.info_block}>
					<div>Docs</div>
					<div>
						<div><ExternalLink link={"https://docs.magicyearn.io"}>&#8250; Whitepaper</ExternalLink></div>
						<div><ExternalLink link={"https://docs.magicyearn.io/ecosystem"}>&#8250; Ecosystem</ExternalLink></div>
						<div><ExternalLink link={"https://docs.magicyearn.io/magic-yearn-nfts"}>&#8250; NFTs</ExternalLink></div>
						<div><ExternalLink link={"https://docs.magicyearn.io/fee-reduction"}>&#8250; Fee Reduction</ExternalLink></div>
						<div><ExternalLink link={"/pdfs/magic_yearn_audit.pdf"}>&#8250; Audit</ExternalLink></div>
					</div>
				</div>
				<div className={styles.info_block}>
					<div>Legacy</div>
					<div>
						<div><ExternalLink link={"https://teneo.magicyearn.io"}>&#8250; Teneo Finance</ExternalLink></div>
						<div><ExternalLink link={"https://teneo.magicyearn.io/pdfs/litepaper.pdf"}>&#8250; Teneo Litepaper</ExternalLink></div>
						<div><ExternalLink link={"https://teneo.magicyearn.io/pdfs/audit.pdf"}>&#8250; Teneo Audit</ExternalLink></div>
					</div>
				</div>
				<div className={styles.info_block}>
					<div>Legal</div>
					<div>
						<div><ExternalLink link={"https://docs.magicyearn.io/legal/terms-and-conditions"}>&#8250; Terms and Conditions</ExternalLink></div>
						<div><ExternalLink link={"https://docs.magicyearn.io/legal/privacy-policy"}>&#8250; Privacy Policy</ExternalLink></div>
						<div><ExternalLink link={"https://docs.magicyearn.io/legal/user-agreement"}>&#8250; User Agreement</ExternalLink></div>
					</div>
				</div>
			</div>

			<hr/>

			<div className={styles.row_3}>
				<span>Magic Yearn {year} - All rights reserved.</span>
				<span> ~ building defi projects with passion</span>
			</div>
		</footer>
    );
}